export const POPUP_CLASS_NAME = 'admin-center-matrices-custom-category-select';
